import DataVoteBlock from './DataVoteBlock';

export default DataVoteBlock;
